export default __webpack_public_path__ + "static/media/perfomaq_jocelyn.19dbebdc.jpg";